import React from 'react';
import { isIAFCheckboxCheckableSignals } from '../../lib/helpers/isCheckboxCheckable';

function IAFCustomCheckboxesSignals({ data = {}, profile = {} }) {
  return (
    <>
      {isIAFCheckboxCheckableSignals({ data }) ? (
        <input
          type="checkbox"
          onChange={(e) => {
            e.stopPropagation();
            data.checked = !data.checked;
          }}
        />
      ) : (
        <></>
      )}
    </>
  );
}

export default IAFCustomCheckboxesSignals;
